import { render, staticRenderFns } from "./MyCenter.vue?vue&type=template&id=89f80334&scoped=true"
import script from "./MyCenter.vue?vue&type=script&lang=js"
export * from "./MyCenter.vue?vue&type=script&lang=js"
import style0 from "./MyCenter.vue?vue&type=style&index=0&id=89f80334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f80334",
  null
  
)

export default component.exports